import React, { useState, useEffect, useContext } from "react";
import CustomButton from "components/common/Button/CustomButton";
import PaginationComponent from "components/common/Pagination/index";
import {
  emptyPaginationObj,
  FUNDING_CASE_NOTES_LIMIT,
} from "Constants/constant";
import { getPaginationObj, classNames } from "Utils/utils";
import CaseNoteReportModal from "./CaseNoteReportModal";
import SubmittedCaseNotesList from "pages/SupportCoordination/Participant/ParticipantProfile/CaseNotes/Submitted/SubmittedCaseNotesList";
import DeleteCaseNote from "./DeleteCaseNote";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { LoginContext } from "helpers/LoginContext";
import { canDeleteAhCaseNote } from "helpers/RolesPermission";

const ParticipantFundingCaseNote = (props) => {
  const {
    setOpenUpdateCaseNoteModal,
    getCaseNoteDetailRequest,
    reportLoading,
    caseNotesList,
    getCaseNotesRequest,
    casNotesListLoading,
    getCatogeryListRequest,
    uuid,
    getReportRequest,
    selectedFunding,
    cosParticipantsProfile,
    isRefreshCaseNotes,
  } = props;

  const { isUserGracePeriodOver } = useContext(LoginContext);

  const [openReportModal, setOpenReportModal] = useState(false);
  const [openCaseNoteModal] = useState(false);
  const [paginationObj, setPaginationObj] = useState(
    caseNotesList ? getPaginationObj(caseNotesList) : emptyPaginationObj
  );
  const [refreshTableAfterDelete, setRefreshTable] = useState(false);

  useEffect(() => {
    if (caseNotesList) {
      setPaginationObj({
        ...getPaginationObj(caseNotesList),
      });
    }
  }, [caseNotesList]);

  const handleFetch = (page) => {
    if (
      uuid &&
      caseNotesList &&
      caseNotesList.current_page !== page &&
      selectedFunding
    ) {
      getCaseNotesRequest({
        funding_id: selectedFunding.value,
        id: uuid,
        page,
        per_page: FUNDING_CASE_NOTES_LIMIT,
      });
    }
  };

  useEffect(() => {
    if (selectedFunding && !openCaseNoteModal) {
      getCaseNotesRequest({
        funding_id: selectedFunding.value,
        id: uuid,
        page: paginationObj.page,
        per_page: FUNDING_CASE_NOTES_LIMIT,
      });
    }
  }, [
    selectedFunding,
    openCaseNoteModal,
    isRefreshCaseNotes,
    refreshTableAfterDelete,
  ]);

  return (
    <>
      <div className='bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden flex flex-col'>
        <div className='bg-gray-100 font-medium min-h-[3rem] py-2 px-3 border-b flex justify-between items-center rounded-t flex-shrink-0'>
          <div className='text-[#101828] font-semibold text-base'>
            Submitted Case Notes
          </div>
          <div className='flex space-x-2'>
            <CustomButton
              isDisabled={isUserGracePeriodOver}
              clickHandler={() => {
                if (isUserGracePeriodOver) return;
                setOpenReportModal(true);
              }}
              variant='primary'
              label='Generate Report'
              Icon={<HiOutlineDocumentReport className='h-5 w-5' />}
              type='button'
              cssClass={classNames(
                "flex items-center rounded-lg background-gradient border-gradient text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2",
                !isUserGracePeriodOver && "cursor-pointer"
              )}
            />
          </div>
        </div>

        <div className='max-h-[min(560px,60vh)] overflow-y-auto custom-scroll caseNotesContainer'>
          <SubmittedCaseNotesList
            caseNotesList={caseNotesList?.data}
            casNotesListLoading={casNotesListLoading}
            cosParticipantsProfile={cosParticipantsProfile}
            getCaseNoteDetailRequest={getCaseNoteDetailRequest}
            setOpenUpdateCaseNoteModal={setOpenUpdateCaseNoteModal}
            setRefreshTable={setRefreshTable}
            refreshTableAfterDelete={refreshTableAfterDelete}
            DeleteModal={DeleteCaseNote}
            canDelete={canDeleteAhCaseNote}
            caseNoteApiModule='ah'
          />
        </div>
      </div>

      {caseNotesList?.data?.length > 0 && (
        <div className='py-4 px-2 mt-3'>
          <PaginationComponent
            page={paginationObj.page}
            activeListLength={caseNotesList?.data}
            limit={FUNDING_CASE_NOTES_LIMIT}
            totalList={
              paginationObj.totalPages === 1
                ? caseNotesList?.data?.length
                : paginationObj.total
            }
            handlePagination={(e) => handleFetch(e)}
            totalPages={paginationObj.totalPages}
          />
        </div>
      )}

      {openReportModal && (
        <CaseNoteReportModal
          selectedFunding={selectedFunding}
          reportLoading={reportLoading}
          getCatogeryListRequest={getCatogeryListRequest}
          openReportModal={openReportModal}
          closeModal={() => setOpenReportModal(false)}
          uuid={uuid}
          getReportRequest={getReportRequest}
        />
      )}
    </>
  );
};

export default ParticipantFundingCaseNote;
